 <!-- Barra azioni -->
    <div class="actions ms-3 me-3">
        <div class="actions-row">
            <!-- Input file nascosto ma accessibile -->
            <input #fileInput type="file" class="sr-only" accept=".txt" (change)="onFileSelected($event)" />

            <!-- Scegli file -->
            <button type="button" class="btn-primary btn-control choose-file-button" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="openFileDialog(fileInput)" aria-label="Scegli file">
                <mat-icon aria-hidden="true">folder_open</mat-icon>
                <span>Scegli file</span>
            </button>

            <!-- Badge pill con nome file -->
            <div *ngIf="pendingFile" class="file-pill-wrapper" aria-live="polite">
                <output class="pill-badge btn-control" aria-label="File selezionato">
                    <span class="pill-text">{{ pendingFile.name }}</span>
                    <button type="button" class="pill-close" (click)="removeFile(fileInput)"
                        aria-label="Rimuovi file selezionato">
                        <mat-icon aria-hidden="true">cancel</mat-icon>
                    </button>
                </output>
            </div>

            <!-- Seleziona lingua -->
            <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic" class="lang-select equal-height mx-3">
                <mat-label>Seleziona la lingua</mat-label>
                <mat-select [value]="selectedLang" (selectionChange)="changeLang($event.value)" aria-label="Seleziona la lingua">
                    <mat-option *ngFor="let l of languages" [value]="l.code">
                        {{ l.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Carica file -->
            <button type="button" class="btn-primary btn-upload btn-control ms-2 me-3" [disabled]="!pendingFile || isUploading || !selectedLang || !canDoActions('BACKOFFICE_ADMIN')" (click)="onUpload()" aria-label="Carica file">
                <ng-container *ngIf="!isUploading; else loading">
                    <mat-icon aria-hidden="true">cloud_upload</mat-icon>
                </ng-container>
                <ng-template #loading>
                    <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                </ng-template>
                <span>Carica file</span>
            </button>
        </div>
    </div>
